<template>
  <div class="card overflow-hidden p-4 pt-0">
      <DetailHeader :headerTitle="'재료이력 상세'" :cardHeader="'pb-3 pt-4 ps-0'"/>
        <div
          class="page-header min-height-300 border-radius-xl opacity-8 page-header-fallback"
          :style="bgImageUrl 
                  ? { backgroundImage: `url('${bgImageUrl}')`,
                      backgroundPositionY: '50%' } 
                  : { backgroundColor: '#f9f9f9' }"
        >
        </div>
        <div class="mx-4 overflow-hidden card card-body blur shadow-blur mt-n6">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <soft-icon
                      :icon="materialInfo.iconName"
                      shadow="sm"
                      style="font-size: 24px;"
                    />
              </div>
            </div>
            <div class="col-auto my-auto ps-0">
              <div class="h-100">
                <h5 class="mb-1">{{materialInfo.name}}</h5>
                <p class="mb-0 text-sm font-weight-bold">{{sgtin}}</p>
              </div>
            </div>
            <div
              class="mx-auto me-5 mt-3 col-lg-1 col-md-6 my-sm-auto ms-sm-auto"
            >
            </div>
          </div>
        </div>


      <div class="py-4 ">
        <div class="row mt-4">
          <div class="col-md-4 mt-2">
            <material-info-card
              title="재료 정보"
              :info="materialInfo"
            />
          </div>
          <div class="col-md-4 mt-2">
            <product-trace-card
              class="h-100"
              title="제조 이력"
              :traceList="traceList"
            />
          </div>
          <div class="col-md-4 mt-2">
            <timeline-list
              title="타임라인"
            >
              <timeline-item
                v-for="trace in traceList" :key="trace.id"
                color="info"
                :icon="getIconByBizStep(trace.bizStep)"
                :title="trace.stepName"
                :date-time="formatDate(trace.eventTime)"
              />
            </timeline-list>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import DetailHeader from "@/components/DetailHeader.vue";
import SoftIcon from "@/components/SoftIcon.vue";
import TimelineList from "@/views/components/TimelineList.vue";
import TimelineItem from "@/views/components/TimelineItem.vue";
import ProductTraceCard from "@/views/components/productTrace/ProductTraceCard.vue";
import MaterialInfoCard from "@/views/components/productTrace/MaterialInfoCard.vue";
import setNavPills from "@/assets/js/nav-pills.js";
import api from '@/api/api';

const bizStepIconMap = {
  "urn:epcglobal:cbv:bizstep:receiving": "box-2",      // ni-box-2
  "urn:epcglobal:cbv:bizstep:processing": "settings-gear-65",
  "urn:epcglobal:cbv:bizstep:assembling": "collection",
  "urn:epcglobal:cbv:bizstep:inspecting": "check-bold",
	"urn:epcglobal:cbv:bizstep:commissioning": "box-2",
  "urn:epcglobal:cbv:bizstep:packing": "archive-2",
  "urn:epcglobal:cbv:bizstep:shipping": "send",
  "urn:epcglobal:cbv:bizstep:transporting": "delivery-fast",
  "urn:epcglobal:cbv:bizstep:receiving_at_retail": "shop"
}

export default {
  name: "ProfileOverview",
  components: {
    DetailHeader,
    ProductTraceCard,
    TimelineList,
    TimelineItem,
    SoftIcon,
    MaterialInfoCard
  },
  computed: {
  },
  data() {
    return {
      mfId: '',
      id: this.$route.query.id,
      sgtin: this.$route.query.sgtin,
      bgImageUrl: this.$route.query.bgImageUrl,
      materialInfo: {},
      traceList: [],
    };
  },
  mounted() {
    setNavPills();
    this.init();
  },
  methods: {
    init(){
      this.mfId = localStorage.getItem('mfId');
      this.fetchProductInfo();
      this.fetchTraceList();
    },
    async fetchProductInfo() {
      try {
        const response = await api.get(`/rawMaterial`, {
          params: {
            id: this.id,
            urn: this.sgtin
          }
        });
        const result = response.data.result;
        
        this.materialInfo = result.rawMaterial;
      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    async fetchTraceList() {
      try {
        const response = await api.get(`/productTrace/traceList?mfId=${this.mfId}&urn=${this.sgtin}`);
        const result = response.data.result;
        if(result.traceList && result.traceList.length > 0){
          this.traceList = result.traceList;
        }else{
          this.traceList = [];
        }

      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    getIconByBizStep(bizStep) {
      return bizStepIconMap[bizStep] || 'ni-tag'; // fallback 아이콘
    },
  }
};
</script>

<style scoped>
.page-header-fallback {
  min-height: 300px;
  background-color: #f0f0f0;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.8;
}
</style>